const get = state => state.adTesterOverview;

export const getAdTesterOverviewDataSelector = state => get(state).data;
export const getAdTesterOverviewSelectedCountrySelector = state => get(state).selectedCountry;
export const getAdTesterOverviewSelectedAdsSelector = state => get(state).selectedComparisonAds;
